export default `float e,v,u;
  e = v = 2;
  for(int j=0;j++<12;j>3?e=min(e,length(p.xz+length(p)/u*.55)/v-.006),p.xz=abs(p.xz)-.7,p:p=abs(p)-.86)
    v /= u = dot( p, p ),
    p /= u,
    p.y = 1.7 - p.y;
  return e;
}`